export const color = {
  black: "#000",
  white: "#fff",
  beatfit: "#2ab0b3",
  lightGray: "#ccc",
  blueGreen: "#aaeef0",
  blueGray: "#d7d8e1",
  weekBlue: "#fbfbff",
}

export const font = {
  W3: "HiraginoSans-W3",
  W5: "HiraginoSans-W5",
  W6: "HiraginoSans-W6",
  W8: "HiraginoSans-W8",
}
